// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AgentInfo = require("../../common/Components/AgentInfo.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DevelopmentProjectSearchResultAgent_developmentProject_graphql = require("../../../__generated__/DevelopmentProjectSearchResultAgent_developmentProject_graphql.bs.js");

let convertFragment = DevelopmentProjectSearchResultAgent_developmentProject_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentProjectSearchResultAgent_developmentProject_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultAgent_developmentProject_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentProjectSearchResultAgent_developmentProject_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentProjectSearchResultAgent_developmentProject_graphql.node, convertFragment, fRef);
}

let ProjectFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentProjectSearchResultAgent$WithoutErrorBoundary(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  let match = RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultAgent_developmentProject_graphql.node, convertFragment, props.project);
  let agent = match.agent;
  if (agent !== undefined) {
    return JsxRuntime.jsx(AgentInfo.make, {
      agent: agent.fragmentRefs,
      size: size
    });
  } else {
    return null;
  }
}

let WithoutErrorBoundary = {
  make: DevelopmentProjectSearchResultAgent$WithoutErrorBoundary
};

function DevelopmentProjectSearchResultAgent(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "development project agent",
    children: JsxRuntime.jsx(DevelopmentProjectSearchResultAgent$WithoutErrorBoundary, {
      project: props.project,
      size: size
    })
  });
}

let make = DevelopmentProjectSearchResultAgent;

exports.ProjectFragment = ProjectFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* AgentInfo Not a pure module */
